import { Component } from '@theme/component';

export function resolveSelection(data, input) {
  const family = input.family === 'roll' ? 'roll' : 'flag';
  const model = family === 'roll' ? (input.model === 'double' ? 'double' : 'single') : (['feather', 'drop', 'square'].includes(input.model) ? input.model : 'feather');
  const sizes = data[model]?.sizes;
  if (!sizes || !Object.keys(sizes).length) return null;
  const fallback = family === 'flag' ? 'M' : '85';
  const size = Object.hasOwn(sizes, input.size) ? input.size : (Object.hasOwn(sizes, fallback) ? fallback : Object.keys(sizes)[0]);
  const quantity = Number(input.quantity);
  return { family, model, size, spec: sizes[size], sizes: Object.keys(sizes), quantity, validQuantity: Number.isInteger(quantity) && quantity >= 1 && quantity <= 9999 };
}

class VPQuote extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }
  updatedCallback() {
    super.updatedCallback();
    this.initialize();
  }
  initialize() {
    try {
      const raw = JSON.parse(this.querySelector('[data-model-data]').textContent);
      this.models = typeof raw === 'string' ? JSON.parse(raw) : raw;
      this.strings = JSON.parse(this.querySelector('[data-pdp-strings]').textContent);
      this.environmentSelected = false;
      this.updateSelection();
    } catch {
      const status = this.querySelector('[data-pdp-error]');
      if (status) status.hidden = false;
    }
  }
  updateSelection(event) {
    if (!this.models || !this.strings) return;
    const form = this.querySelector('form');
    const selected = (key) => form.querySelector(`[data-option="${key}"]:checked`);
    const quantity = form.querySelector('[data-option="quantity"]');
    const model = selected('model')?.value ?? this.dataset.model;
    const size = selected('size')?.value ?? this.dataset.size;
    const state = resolveSelection(this.models, {family:this.dataset.family, model, size, quantity:quantity.value});
    if (!state) return;
    this.state = state;
    for (const input of form.querySelectorAll('[data-option="size"]')) {
      input.disabled = !state.sizes.includes(input.value);
      input.checked = input.value === state.size;
    }
    if (event?.target?.matches('[data-option="model"]')) this.environmentSelected = false;
    this.showSelectedImage();
    const title = state.family === 'flag' ? `${this.strings.flagTitle} ${state.model.charAt(0).toUpperCase() + state.model.slice(1)}` : this.strings.rollTitle;
    this.setText('title', title);
    const row = state.spec;
    const modelLabel = selected('model')?.closest('label')?.querySelector('span')?.textContent.trim() ?? model;
    const sizeLabel = state.family === 'flag' ? `${state.size} (${row[0]} cm)` : `${state.size} × 200 cm`;
    const extra = form.querySelector('[data-option="extra"]');
    const extraLabel = extra.options[extra.selectedIndex]?.text ?? '';
    const quantityLabel = state.validQuantity ? `${state.quantity} ${this.strings.pcs}` : '–';
    const summary = [modelLabel, sizeLabel, extraLabel, quantityLabel].join(' · ');
    this.setText('summary', summary);
    if (state.family === 'flag') {
      this.setText('size', row[0] + ' cm');
      this.setText('height', row[1] + ' cm');
      this.setText('shape', modelLabel);
      this.setText('weight', `${this.strings.flagWeight} ${row[2]} kg · ${this.strings.poleWeight} ${row[3]} kg`);
      this.setText('sizehelp', `${this.strings.printLabel}: ${row[0]} cm · ${this.strings.heightLabel}: ${row[1]} cm`);
    } else {
      this.setText('size', `${state.size} × 200 cm`);
      this.setText('weight', row[0] + ' kg');
      this.setText('sides', state.model === 'double' ? this.strings.twoFaces : this.strings.oneFace);
      this.setText('sizehelp', state.model === 'double' ? this.strings.doubleSizeHelp : this.strings.rollSizeHelp);
    }
    form.querySelector('[data-product-value]').value = title;
    form.querySelector('[data-summary-value]').value = summary;
    this.composeBody();
  }
  composeBody() {
    const form = this.querySelector('form');
    const title = form.querySelector('[data-product-value]').value;
    const summary = form.querySelector('[data-summary-value]').value;
    const message = form.querySelector('textarea[name="contact[Beskrivelse / Message]"]')?.value.trim() ?? '';
    form.querySelector('[data-body-value]').value = [title, summary, this.strings.referenceNote, '', message].join('\n');
  }
  prepareRequest(event) {
    this.updateSelection();
    if (!this.state?.validQuantity) {
      event.preventDefault();
      this.querySelector('[data-option="quantity"]').reportValidity();
    }
  }
  setText(key, value) {
    for (const element of this.querySelectorAll(`[data-pdp-text="${key}"]`)) element.textContent = value;
  }
  showSelectedImage() {
    if (!this.state) return;
    const model = this.environmentSelected ? 'environment' : this.state.model;
    for (const figure of this.querySelectorAll('[data-model-image]')) {
      figure.hidden = figure.dataset.modelImage !== model || (Boolean(figure.dataset.sizeImage) && figure.dataset.sizeImage !== this.state.size);
    }
    for (const button of this.querySelectorAll('[data-gallery-mode]')) button.setAttribute('aria-pressed', String((button.dataset.galleryMode === 'environment') === this.environmentSelected));
  }
  showModel() {
    this.environmentSelected = false;
    this.showSelectedImage();
  }
  showEnvironment() {
    this.environmentSelected = true;
    this.showSelectedImage();
  }
  zoomImage(event) {
    const dialog = this.querySelector('dialog');
    const image = this.querySelector('[data-model-image]:not([hidden]) img');
    if (!image || !dialog) return;
    this.zoomTrigger = event?.currentTarget ?? this.querySelector('[data-zoom-button]');
    const preview = dialog.querySelector('img');
    preview.src = image.currentSrc || image.src;
    preview.alt = image.alt;
    dialog.showModal();
  }
  closeImage() {
    this.querySelector('dialog')?.close();
    this.querySelector('[data-zoom-button]')?.focus();
  }
}
if (!customElements.get('vp-quote-component')) customElements.define('vp-quote-component', VPQuote);
